import styled from "styled-components";


export const Wrapper = styled.div`
    background: var(--darkGrey);
    /* Full-width background strip for the nav bar */
    width: 100%;
`;



/* Content now just constrains the Nav's horizontal max-width — padding/height
   are handled inside Nav itself so the logo and links stay on one row. */
export const Content = styled.div`
    width: 100%;
`;


export const LogoImg = styled.img`
    /* Constrain logo so it doesn't crowd the nav links */
    width: 200px;
    flex-shrink: 0;
    display: block;

    @media screen and (max-width: 768px) {
        width: 150px;
    }
`;


export const TMDBLogoImg = styled.img`
width: 300px;

@media screen and (max-width: 500px){

   width: 80px; 

}
`;


